'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'sign-post';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e624';
var svgPathData = 'M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24V64H417c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5H280V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48H232V24zM449.5 160l-40-48H80v96H409.5l40-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignPost = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;